// Local cache helpers for comments
const CACHE_INDEX_KEY = "comments_cache_index";
const CACHE_MAX_ENTRIES = 50;

export const readCache = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const readCacheIndex = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_INDEX_KEY) || "[]");
  } catch {
    return [];
  }
};

export const writeCacheIndex = (index) => {
  try {
    localStorage.setItem(CACHE_INDEX_KEY, JSON.stringify(index));
  } catch {}
};

export const writeCache = (key, value) => {
  try {
    let index = readCacheIndex().filter((k) => k !== key);
    index.push(key);
    while (index.length > CACHE_MAX_ENTRIES) {
      const evicted = index.shift();
      try {
        localStorage.removeItem(evicted);
      } catch {}
    }
    writeCacheIndex(index);
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};
